const INITIAL_STATE = {
    language: [],
    count: 0,
    loading: false
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case "GET_LANGUAGES": {
        return {
          ...state,
          language: action.data,
          count: action.count,
          loading: false
        }
      }
      default:
        return state
    }
  }
  